import { MyTableComponent, Button } from "components"
import { useEffect, useState } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import { useSettingsStateColourQuery } from "../../store/Features/settings/settingsStateColour-api-slice"

import { IStateColours, IColourInformation } from "@types"
export const StateColor = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data, isLoading } = useSettingsStateColourQuery()

 const [selectedData, setSelectedData] = useState<IColourInformation[]>([])

 const handleColorChange = (color: string | any, id: number) => {
  const updatedData = selectedData.map((entry, index) =>
   index === Number(id) ? { ...entry, colour_value: color } : entry,
  )
  // Update the state with the new array
  setSelectedData(updatedData)
 }

 const columns = [
  {
   Header: t("Color"),
   Cell: ({ row }: any) => (
    <div className="flex justify-center">
     <div className="w-6 h-6">
      <input
       className="w-full "
       type="color"
       value={row?.original?.colour_value}
       onChange={(e) => {
        handleColorChange(e.target.value, row?.id)
       }}
      />
     </div>
    </div>
   ),
  },
  { Header: t("colourState"), accessor: "colour_state" },
  { Header: t("systemState"), accessor: "system_state" },
  { Header: t("deviceState"), accessor: "device_state" },
  { Header: t("operatingMode"), accessor: "operating_mode" },
  { Header: t("trafficEngineering"), accessor: "traffic_engineering" },
 ]
 useEffect(() => {
  if (data) {
   const _colorInformation: IColourInformation[] = []
   data?.forEach((item: IStateColours) => {
    item?.color_information?.filter((item: any) => _colorInformation.push(item))
   })
   setSelectedData(_colorInformation)
  }
 }, [data])

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <h1 className="Jakarta-font font-bold text-xl py-6">{t("editStatusColors")}</h1>
   <Box bg="highlight" className="flex justify-between items-center py-4 px-2">
    <h1 className="Jakarta-font font-bold text-xl">{t("editStatusColors")}</h1>
    <div className="flex">
     <div className="mr-2">
      <Button size={"xl"}>{t("save")}</Button>
     </div>
     <Box bg="text" className="rounded">
      <Button size={"xl"} color={"gray"}>
       {t("cancel")}
      </Button>
     </Box>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
    isLoading={isLoading}
   />
  </div>
 )
}
